import { Box, Checkbox, Divider, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FC } from 'react';
import { useAppSelector } from 'shared/lib/hooks/hooks';
import { useAppDispatch } from 'shared/config/configureStore';
import { setIsInsuranceNeeded } from 'api/slice/marathonsSlice/marathonsSlice';

interface IInsuranceProps {

}

const Insurance: FC<IInsuranceProps> = ({

}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const marathon = useAppSelector(
    (state) => state.marathons.marathonsById.response.data
  );

  const distanceId = useAppSelector(
    (state) => state.marathons.marathonsById.params.distance
  );

  const isInsuranceNeeded = useAppSelector((state) => state.marathons.marathonsById.params.insurance);

  const hasDistanceInsurance =
    marathon?.distances.find((d) => String(d.id) === distanceId)
      ?.hasInsurance;

  return hasDistanceInsurance ? (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
      }}
    >
      <Box display="flex" columnGap="16px" paddingBottom="16px">
        <Typography
          sx={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px" }}
        >
          {t("registerToMarathon.insurance")}
        </Typography>
        <Divider
          sx={{
            flexGrow: 1,
            height: "1px",
            my: 2,
            backgroundColor: "#ECF2F7",
          }}
        />
      </Box>

      <Typography sx={{ marginBottom: "16px" }}>
        {t("registerToMarathon.insuranceInfo")}
      </Typography>

      <Box display="flex" alignItems="center">
        <Box display="flex" alignItems="center">
          <Checkbox
            id="isInsuranceNeeded"
            checked={isInsuranceNeeded}
            onChange={() => dispatch(setIsInsuranceNeeded(!isInsuranceNeeded))}
            icon={<RadioButtonUncheckedIcon sx={{ fontSize: 24 }} />}
            checkedIcon={<CheckCircleIcon sx={{ fontSize: 24 }} />}
            sx={{ paddingLeft: 0 }}
          />
          <label>{t("registerToMarathon.buyInsurance")}</label>
        </Box>

        <Divider
          sx={{
            flexGrow: 1,
            height: "1px",
            alignSelf: "center",
            backgroundColor: "#ECF2F7",
            mx: 2,
          }}
        />

        <Typography>
          {marathon?.insurancePrice} {t("myMarathon.som")}
        </Typography>
      </Box>
    </Paper>
  ) : null;
};

export default Insurance;
